// src/store/modules/permission.js
import { defineStore } from 'pinia'
import { http } from '@/utils/request'

export const usePermissionStore = defineStore('permission', {
  state: () => ({
    menus: [],
    permissions: [],
    routesLoaded: false,
  }),

  getters: {
    menuTree: (state) => buildTree(state.menus, null),
  },

  actions: {
    async fetchMenus() {
      try {
        const res = await http.get('/menu/user')
        if (res.code === 200) {
          this.menus = res.data
          return res.data
        }
        return []
      } catch {
        return []
      }
    },

    setPermissions(permissions) {
      this.permissions = permissions || []
    },

    hasPermission(code) {
      return this.permissions.includes(code)
    },

    resetRoutes() {
      this.routesLoaded = false
      this.menus = []
      this.permissions = []
    },
  },
})

// 构建菜单树
function buildTree(list, parentId) {
  return list
    .filter(item => (parentId === null && !item.parentId) || item.parentId === parentId)
    .map(item => ({
      ...item,
      children: buildTree(list, item.id),
    }))
    .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
}
